import { applyI18n, t } from '../i18n';
import { enterHelpPageMode, leaveHelpPageMode } from '../help/help';

export function HelpPage(): HTMLElement {
  const page = document.createElement('section');
  page.className = 'panel help-page-root';
  page.setAttribute('data-help-page', '1');

  page.innerHTML = `
    <div class="help-shell">
      <div class="help-toolbar">
        <h1 id="helpTitle"></h1>
        <div class="help-search-wrap">
          <input id="helpSearch" class="help-search" type="search" />
          <div class="help-match-nav" hidden>
            <button type="button" data-help-match="prev">&lt;</button>
            <span class="help-match-count" aria-live="polite">0/0</span>
            <button type="button" data-help-match="next">&gt;</button>
          </div>
        </div>
      </div>
      <div class="help-layout">
        <nav id="helpNav" class="help-nav" aria-label="${t('help.topics')}"></nav>
        <div id="helpBody" class="help-body"><p class="help-muted">${t('help.loading')}</p></div>
      </div>
    </div>
  `;

  applyI18n(page);
  void enterHelpPageMode(page);

  const observer = new MutationObserver(() => {
    if (!document.body.contains(page)) {
      observer.disconnect();
      leaveHelpPageMode();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  return page;
}
